import { render, staticRenderFns } from "./eChooseTeacher.vue?vue&type=template&id=0a1b6c7a&scoped=true"
import script from "./eChooseTeacher.vue?vue&type=script&lang=js"
export * from "./eChooseTeacher.vue?vue&type=script&lang=js"
import style0 from "./eChooseTeacher.vue?vue&type=style&index=0&id=0a1b6c7a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a1b6c7a",
  null
  
)

export default component.exports